<template>
  <layout-account>
    <div class="account-container" slot="main">
      <div class="steps">
        <a-steps :current="0" size="small">
          <a-step title="填写账号信息" />
          <a-step title="注册成功" />
        </a-steps>
      </div>
      <div class="reg-data">
        <h1>请填写您的账号信息</h1>
        <a-form
          :form="regForm"
          @submit="submitReg"
        >
          <a-form-item>
            <a-input
              v-decorator="[
              'identity',
              { rules: [{ required: true, message: '请输入手机号或邮箱!' }, {validator: identityVerify}] },
            ]"
              size="large"
              placeholder="输入你的手机号或邮箱"
            />
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="[
              'code',
              { rules: [{ required: true, message: '请输入验证码!' }] },
            ]"
              size="large"
              placeholder="输入验证码"
            >
              <a-button v-if="sendCodeCountDown == 0" slot="suffix" @click="sendVerifyCode" :disabled="!regForm.getFieldValue('identity') || hasErrors(regForm.getFieldsError(['identity']))" type="link">
                获取验证码
              </a-button>
              <a-button v-if="sendCodeCountDown > 0" disabled slot="suffix">{{sendCodeCountDown}} 秒</a-button>
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="[
              'password',
              { rules: [{ required: true, message: '请输入登陆密码!' }, { min: 8, message: '密码不少于8位!' }, { max: 20, message: '密码不多于20位!' }] },
            ]"
              :type="displayPassword ? 'text' : 'password'"
              size="large"
              placeholder="设置你的登陆密码"
            >
              <a-icon slot="suffix" :type="displayPassword? 'eye' : 'eye-invisible'" @click="displayPassword = !displayPassword" style="color: rgba(0,0,0,.25)" />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="[
              'name',
              { rules: [{ required: true, message: '请输入你的姓名!' }] },
            ]"
              size="large"
              placeholder="输入你的姓名"
            />
          </a-form-item>
          <a-form-item>
            <a-checkbox
              v-decorator="[
              'agree',
              {
                valuePropName: 'checked',
                initialValue: true,
              },
            ]"
            >
              阅读并同意<a class="login-form-forgot" href="">《服务条款及隐私政策》</a>
            </a-checkbox>
            <a-alert
              v-if="errorResp"
              @close="clearErrorTimeout"
              style="margin-bottom: 11px"
              type="error"
              :message="errorResp.message"
              banner
              closable
            />
            <a-button :disabled="hasErrors(regForm.getFieldsError())" type="primary" size="large" html-type="submit" class="login-form-button">
              即刻开始
            </a-button>
          </a-form-item>
          <a-form-item class="link">
            <a href="/account/login">已有账号</a>
          </a-form-item>
        </a-form>
      </div>
    </div>
  </layout-account>
</template>

<script>
import LayoutAccount from '../../layouts/account'

export default {
  name: 'account-create',
  components: {
    'layout-account': LayoutAccount
  },
  data () {
    return {
      displayPassword: false,
      sendCodeCountDown: 0,
      verifyCode: false,
      errorTimeOut: false,
      errorResp: false,
      regForm: this.$form.createForm(this, { name: 'regForm' })
    }
  },
  methods: {
    hasErrors (fieldsError) {
      return Object.keys(fieldsError).some(field => fieldsError[field])
    },
    identityVerify (rule, value, callback) {
      let error = false
      if (value) {
        if (!isNaN(value)) {
          if (!/^[1][34578]\d{9}$/.test(value) || !/^[1-9]\d*$/.test(value) || value.length !== 11) {
            error = '请输入正确的手机号'
          }
        } else if (value.indexOf('@') > 0) {
          if (!/^[A-Za-z0-9]+[A-Za-z0-9-_.]*@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value)) {
            error = '请输入正确的邮箱'
          }
        } else {
          error = '请输入手机号或邮箱'
        }
      } else {
        error = false
      }
      if (error) {
        callback(error)
      } else {
        callback()
      }
    },
    submitReg (e) {
      e.preventDefault()
      const _this = this
      this.regForm.validateFieldsAndScroll((err, values) => {
        if (!err) {
          const _data = {...values}
          _data.identity_type = values.identity.indexOf('@') > 0 ? 2 : 1
          _data.code = {value: values.code, key: _this.verifyCode.key}
          _this.axios.post('/api/account?expand=menu', _data).then(function (resp) {
            _this.$store.commit('setToken', resp.token)
            _this.$store.commit('setAccount', resp.account)
            _this.$router.replace('/')
          }).catch(function (err) {
            _this.errorResp = err
            _this.errorTimeOut = setTimeout(function () {
              _this.clearErrorTimeout()
            }, 3000)
          })
        }
      })
    },
    clearErrorTimeout (){
      this.errorResp = false
      if(this.errorTimeOut){
        clearTimeout(this.errorTimeOut)
      }
    },
    codeCountDown () {
      this.sendCodeCountDown = this.sendCodeCountDown - 1
      if(this.sendCodeCountDown > 0){
        const _this = this
        setTimeout(function () {
          _this.codeCountDown()
        }, 1000)
      }
    },
    sendVerifyCode() {
      const identity = this.regForm.getFieldValue('identity')
      const data = {type: 'reg', provider: 'Sms', identity: identity}
      if (identity.indexOf('@') > 0) {
        data.provider = 'Email'
      }
      this.sendCodeCountDown = 30
      const _this = this
      this.axios.post('/api/common/code', data).then(function (resp) {
        _this.verifyCode = resp
        _this.codeCountDown()
      }).catch(function () {
        _this.verifyCode = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import "../../assets/style/var";
  .account-container {
    margin: 0 auto;
    max-width: 360px;
  }

  .steps {
    padding: 30px;
  }

  .reg-data {
    h1 {
      text-align: center;
      font-size: 24px;
      font-weight: 400;
      padding: 20px 0;
    }
    .login-form-button{
      width: 100%;
    }
    .link{
      text-align: center;
      a{
        color: @text-color-secondary;
        &:hover{
          color: @text-color;
        }
      }
    }
  }
</style>
